import { FormEvent, useState } from "react";
import { Button, Card, PageHeader } from "@/components/primitives";
import { CosmosQueryResponse, useCosmosClient } from "@/lib/cosmos-api";

export function DataExplorerPage() {
  const cosmos = useCosmosClient();
  const [prompt, setPrompt] = useState("Show lesson information about leadership");
  const [result, setResult] = useState<CosmosQueryResponse | null>(null);
  const [error, setError] = useState<string | null>(null);

  const run = async (event: FormEvent) => {
    event.preventDefault();
    setError(null);
    try {
      setResult(await cosmos.runQuery(prompt));
      window.localStorage.setItem("cosmos:dataExplorer:lastPrompt", prompt);
    } catch (err) {
      setError(err instanceof Error ? err.message : "Query failed");
    }
  };

  return (
    <div className="page">
      <PageHeader
        eyebrow="Data Explorer"
        title="Raw Cosmos query runner"
        subtitle="Run a read-only query and inspect rows, SQL, and retrieved context."
      />
      <Card>
        <form className="prompt-form" onSubmit={(event) => void run(event)}>
          <textarea value={prompt} onChange={(event) => setPrompt(event.target.value)} />
          <Button>Run query</Button>
        </form>
      </Card>
      {error && <Card className="error-card">{error}</Card>}
      {result && (
        <Card>
          <h2>{result.semanticQuery}</h2>
          <pre>{result.sql}</pre>
          <pre>{JSON.stringify(result.rows, null, 2)}</pre>
        </Card>
      )}
    </div>
  );
}
